import { ACTIVE_CUSTOMER_RULE } from "../shared/ai-copy";

/** The pricing footnote shown in Settings and on the landing page. Counts come from the shared rule, never hand-written. */
export const PRICING_FOOTNOTE = `Based on measured usage: ${ACTIVE_CUSTOMER_RULE.replies} replies, ${ACTIVE_CUSTOMER_RULE.followUps} follow-ups, ${ACTIVE_CUSTOMER_RULE.triage} triage reads and ${ACTIVE_CUSTOMER_RULE.chatTurns} team-chat request per customer each month.`;
